import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {useMediaQuery} from '@s-ui/react-hooks'
import {useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import ListRelatedAds, {listRelatedAdsDisplay} from '@adv-mt/mt-list-related-ads'

const transformToUrl = string => string.toLocaleLowerCase().replaceAll(' ', '_')

export const ListOffers = ({ads, make, model, type}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {OFFER_TYPE_NEW, OFFER_TYPE_SUBSCRIPTION} = config.get('search')
  const makeModel = `${make} ${model}`
  const isHigherThanMobileResolution = useMediaQuery(useMediaQueryBreakpoints.sm)

  const typeBasedProps = {
    [OFFER_TYPE_NEW]: {
      title: i18n.t('MODEL_DETAIL.ADS.TITLE_NEW', {makeModel}),
      linkLabel: i18n.t('MODEL_DETAIL.ADS.CHECK_NEW_ADS_LINK', {model}),
      link: transformToUrl(`${i18n.t('NAVIGATION_MAIN_SEARCH_CARS_NEW_URL')}/${make}/${model}`)
    },
    [OFFER_TYPE_SUBSCRIPTION]: {
      title: i18n.t('MODEL_DETAIL.ADS.TITLE_RENTING', {makeModel}),
      linkLabel: i18n.t('MODEL_DETAIL.ADS.CHECK_RENTING_ADS_LINK', {model}),
      link: transformToUrl(`${i18n.t('NAVIGATION_MAIN_SEARCH_CARS_SUBSCRIPTION_URL')}/${make}/${model}`)
    }
  }

  return (
    <ListRelatedAds
      ads={ads}
      display={isHigherThanMobileResolution ? listRelatedAdsDisplay.grid : listRelatedAdsDisplay.scrolling}
      itemsPerRow={4}
      link={
        <AtomButton design={atomButtonDesigns.LINK} href={typeBasedProps[type]?.link} link>
          {typeBasedProps[type]?.linkLabel}
        </AtomButton>
      }
      title={typeBasedProps[type]?.title}
    />
  )
}

ListOffers.propTypes = {
  ads: PropTypes.array,
  make: PropTypes.object,
  model: PropTypes.object,
  type: PropTypes.string
}
